<template>
  <page-layout>
    <page-header :breadcrumb="['阅读本', '借还柜控制']" />

    <div
      :style="{
        margin: '24px'
      }"
    >
      <div :style="{ textAlign: 'right', marginBottom: '16px' }">
        <el-button size="small" @click="() => store.fetch()">刷新</el-button>
      </div>

      <el-empty v-if="!list.items.length" description="暂无数据" />

      <div
        v-loading="list.loading"
        element-loading-background="rgba(255,255,255, 0)"
        :style="{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 300px))',
          gap: '16px'
        }"
      >
        <div
          v-for="it in list.items"
          :key="it.equId"
          :style="{
            padding: '16px',
            background: '#fff',
            borderRadius: '6px'
          }"
        >
          <div
            :style="{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '8px'
            }"
          >
            <div
              :style="{
                fontSize: '16px',
                fontWeight: '500',
                flex: 1
              }"
            >
              {{ it.equName }}
            </div>

            <el-tag
              :type="it.status === '01' ? 'success' : 'info'"
              :style="{
                height: '20px',
                lineHeight: '18px'
              }"
            >
              {{ it.status === '01' ? '在线' : '离线' }}
            </el-tag>
          </div>

          <div
            :style="{
              color: '#555'
            }"
          >
            设备ID
          </div>
          <div>
            {{ it.equCode }}
          </div>

          <div
            :style="{
              borderBottom: '1px solid #eaeaea',
              margin: '16px 0'
            }"
          ></div>

          <div
            :style="{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '8px'
            }"
          >
            借阅功能
            <el-switch
              :value="it.terminalBorrow"
              :active-value="1"
              :inactive-value="0"
              @change="
                val => {
                  MessageBoxService.confirm({
                    message: val ? '确定开启借阅功能' : '确定关闭借阅功能？',
                    type: 'warning'
                  }).then(() => {
                    store.setBorrow(it, val)
                  })
                }
              "
              :disabled="store.saving"
            />
          </div>

          <div
            :style="{
              display: 'flex',
              justifyContent: 'space-between'
            }"
          >
            归还功能
            <el-switch
              :value="it.terminalReturn"
              :active-value="1"
              :inactive-value="0"
              @change="
                val => {
                  MessageBoxService.confirm({
                    message: val ? '确定开启归还功能' : '确定关闭归还功能',
                    type: 'warning'
                  }).then(() => {
                    store.setReturn(it, val)
                  })
                }
              "
              :disabled="store.saving"
            />
          </div>
        </div>
      </div>
    </div>
  </page-layout>
</template>

<script lang="ts">
import { MessageBoxService } from '@/admin-shared-modules/utils/message-box.service'
import store from './store'

export default {
  components: {},

  data() {
    return { store, list: store.list, MessageBoxService }
  },

  async mounted() {
    await store.fetch()
  },

  methods: {}
}
</script>
